import React from "react";
import style from "./index.module.scss";
import * as Type from "../../config";
export interface IAppProps {
  isShowIcon?: string;
  backColor: string;
  mainTitle: string;
  subTitle: string;
  backIcon: string;
  backImageUrl: string;
}
const App: React.SFC<IAppProps> = props => {
  const { backIcon, backImageUrl, mainTitle, subTitle } = props;
  // const SubTitle = styled.p`
  //   display: ${isShowSubTitle === "show" ? "block" : "none"};
  //   text-align: ${titlePosition[0]};
  // `;
  // const MainTitle = styled.h1`
  //   text-align: ${titlePosition[0]};
  // `;
  return (
    <div className={style.zeusBannerWrap} style={{ backgroundImage: `url(${backImageUrl})` }}>
      <div className={style.zeusBannerBox}>
        <h1 className={style.zeusBannerTitle}>{mainTitle}</h1>
        <h2 className={style.zeusBannerSub}>
          {props.isShowIcon === "show" ? (
            <span className={style.zeusBannerImg}>
              <img src={backIcon} className={style.zeusBannerIcon} />
            </span>
          ) : null}
          {subTitle}
        </h2>
      </div>
    </div>
  );
};

export default App;
